import BaseModel from "./base/baseModel";

export default class CorModel extends BaseModel {
    id?: number = null;
    descricao = "";
}